import React from 'react';
import { Link } from 'react-router-dom';

export default function Home() {



  return (
    <>
    
      {/* Banner One */}
      {<section className="banner-one">
        <div className="container-fluid p-0">
          <div className="banner-one-slider">
            <div className="banner-one-slider-item">
              <div className="banner-one-slider-item-image zoom-in">
                <img alt="banner-images" src="/assets/images/background/partner.png" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-md-10">
                    <div className="banner-one-info">
                      <div className="banner-title fade-left">
                        <h1>Pay Day Loans <br />Made Simple</h1>
                      </div>
                      <div className="section-details fade-left">
                        <p>Wall Street Finz provide payday loans with an easy approval process, professional support, and clear conditions so that you can get the help you need without extra hassle.</p>
                      </div>
                      <div className="fade-in-up">
                        <Link className="btn btn-primary" to="https://loan.wallstreetfinz.com">Apply-Now <i className="flaticon-next"></i></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Slide 2 */}
            <div className="banner-one-slider-item">
              <div className="banner-one-slider-item-image">
                <img alt="banner-images" src="/assets/images/background/bg2.png" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-md-10">
                    <div className="banner-one-info">
                      <div className="banner-title fade-left">
                        <h1> Secure the Support<br />Fast & Easy</h1>
                      </div>
                      <div className="section-details fade-left">
                        <p>Access the support you need with confidence. Quick approval, trusted service, and peace of mind.</p>
                      </div>
                      <div className="fade-in-up">
                        <Link className="btn btn-primary" to="https://loan.wallstreetfinz.com">Apply-Now <i className="flaticon-next"></i></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Slide 3 */}
            <div className="banner-one-slider-item">
              <div className="banner-one-slider-item-image">
                <img alt="banner-images" src="/assets/images/background/bg3.png" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-md-10">
                    <div className="banner-one-info">
                      <div className="banner-title fade-left">
                        <h1>Your Needs. Our Instant Support</h1>
                      </div>
                      <div className="section-details fade-left">
                        <p>When you’re ready to grow, we’re here to lift you forward. Quick, seamless financial help so you can focus on what truly matters.</p>
                      </div>
                      <div className="fade-in-up">
                            <Link className="btn btn-primary" to="https://loan.wallstreetfinz.com">Apply-Now <i className="flaticon-next"></i></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Slide 4
            <div className="banner-one-slider-item">
              <div className="banner-one-slider-item-image">
                <img alt="banner-images" src="/assets/images/background/business.jpg" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-md-10">
                    <div className="banner-one-info">
                      <div className="banner-title fade-left">
                        <h1>Where Business Ambition Meets Capital</h1>
                      </div>
                      <div className="section-details fade-left">
                        <p>Access the funds your business needs to expand, upgrade, or seize opportunities, with a streamlined process designed to save you time and effort.</p>
                      </div>
                      <div className="fade-in-up">
                        <a className="btn btn-primary" href="apply-now">Apply_Now <i className="flaticon-next"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Slide 5 */}
           {/*  <div className="banner-one-slider-item">
              <div className="banner-one-slider-item-image">
                <img alt="banner-images" src="/assets/images/background/personal.jpg" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-7 col-lg-8 col-md-10">
                    <div className="banner-one-info">
                      <div className="banner-title fade-left">
                        <h1>Get Funds When You Need Them Most</h1>
                      </div>
                      <div className="section-details fade-left">
                        <p>Personal loans made easy, with quick processing, minimal paperwork, and the flexibility to use the funds for any purpose you choose.</p>
                      </div>
                      <div className="fade-in-up">
                        <a className="btn btn-primary" href="apply-now">Apply_Now <i className="flaticon-next"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div> 
      </section>
}
      {/* About One */}
      <div className="about-one">
        <div className="container">
          <div className="heading-box text-center">
            <h2 className="heading-title wow fadeInUp animated">Simplifying Loans, Amplifying Your Dreams - Wall Street Finz</h2>
          </div>
          <div className="row gutter-y-30 align-items-center">

            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="about-one-video">
                <img src="assets/images/youtube.png" alt="" />
               {/*  <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen frameBorder="0" src="" title="YouTube video player"></iframe> */}
              </div>
            </div>
              <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="about-one-info">
                <div className="section-details">
                  <p><b>Wallstreet Finz</b>, was built on a powerful mission-to make finance simple and empower people toward their goals without any stress or confusion.</p>
                  <p>Whether you're planning a big life moment, growing a business, managing unexpected expenses, or simply improving your lifestyle, we bring clarity, convenience, and confidence into your financial journey. We understand getting loans can feel overwhelming sometimes. That’s why we designed the entire process to be seamless and easy, with customer-centricity at the very core. From expert advice to tailored loan opportunities, we make sure you always make the smartest financial decision.</p>
                  <p><b>Wall Street Finz</b> has served clients, earning unparalleled trust while providing loan and financial services. Backed by more than a decade of proven experience, we at<b> Wall Street Finz</b> specialize in connecting individuals with the right financial solutions through our wide network of banks and NBFCs. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Two */}
      <div className="features-two">
        <div className="container-fluid p-0">
          <div className="features-slider-two">
            <div className="features-two-slider-item"><h2>Interest Rates.</h2></div>
            <div className="features-two-slider-item"><h2>Principal Amount.</h2></div>
            <div className="features-two-slider-item"><h2>Credit Score.</h2></div>
            <div className="features-two-slider-item"><h2>Loan Term.</h2></div>
            <div className="features-two-slider-item"><h2>Variable Rates.</h2></div>
            <div className="features-two-slider-item"><h2>Monthly Installments.</h2></div>
            <div className="features-two-slider-item"><h2>Debt Consolidation.</h2></div>
          </div>
          {/*  <div class="features-slider-three">
                <div class="features-three-slider-item">
                    <h3>Interest Rates</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Principal Amount</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Credit Score</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Loan Term</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Variable Rates</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Monthly Installments</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Debt Consolidation</h3>
                </div>
                <div class="features-three-slider-item">
                    <h3>Prepayment</h3>
                </div>
            </div> */}
        </div>
      </div>
      
     

      {/* Why Choose One */}
      <section className="why-choose-section-one">
        <div className="why-choose-shape-one-1"><img alt="shape" src="/assets/images/shape/why-choose-shape-1.png" /></div>
        <div className="why-choose-shape-one-2"><img alt="shape" src="/assets/images/shape/why-choose-shape-2.png" /></div>
        <div className="container">
          <div className="row gutter-y-30">
            <div className="col-xl-9 why-choose-left-one">
              <div className="heading-box heading-white">
                <span className="heading-subtitle wow fadeInUp animated animated">⭐ WHY CHOOSE</span>
                <h2 className="heading-title wow fadeInUp animated animated">Wall Street Finz — Your trusted partner for Pay Day Loan solutions and expert financial guidance.</h2>
              </div>
              <div className="why-choose-one-image">
                <img alt="why-choose-image" src="/assets/images/trustedpartner.png" />
              </div>
              
            </div>
            <div className="col-xl-3 col-lg-12">
              <ul className="counter-box-one why-choose-one-box ">
                <li><div className="why-choose-box-one-title">
                      <i className="flaticon-solution"></i>
                      <h4>Seamless Experience</h4>
                    </div><span>01</span><p>Enjoy a smooth, hassle-free journey from application to disbursal.</p></li>
                <li><div className="why-choose-box-one-title">
                      <i className="flaticon-badge"></i>
                      <h4>Quick Approvals</h4>
                    </div><span>02</span><p>Experience faster processing and approvals to help you access funds.</p></li>
               
              </ul>
            </div>
          </div>
        </div>
      </section>

       {/* Services Three */}
      <div className="services-three">
        <div className="services-three-shape-one-1"><img alt="shape" src="/assets/images/shape/services-three-shape-1.png" /></div>
        <div className="services-three-shape-one-2"><img alt="shape" src="/assets/images/shape/services-three-shape-2.png" /></div>
        <div className="container">
          <div className="heading-box text-center">
            <span className="heading-subtitle wow fadeInUp animated animated">🤝 OUR SERVICES</span>
            <h2 className="heading-title wow fadeInUp animated animated">Explore Our Comprehensive Services</h2>
          </div>
          <div className="row gutter-y-40">
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-personal"></i></div>
                <hr />
                <span>01</span>
                <div className="services-three-box-title"><h3>Offer Financial Flexibility</h3></div>
                <div className="services-three-box-info"><p>A selection of customized loan choices intended to quickly handle unforeseen financial difficulties. Our loans are designed to be helpful and flexible, meeting a range of unexpected needs with ease and confidence.</p></div>
             {/*    <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-money-bag"></i></div>
                <hr />
                <span>02</span>
                <div className="services-three-box-title"><h3>Loan for debt Consolidation</h3></div>
                <div className="services-three-box-info"><p>Managing several financial responsibilities is made easier with Loanintap's debt consolidation loan. Reduce the strain of high-interest debt by combining all of your payments into one easy-to-pay installment each month.</p></div>
                {/* <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-mortgage-loan"></i></div>
                <hr />
                <span>03</span>
                <div className="services-three-box-title"><h3>Loan for Quick Purchasing</h3></div>
                <div className="services-three-box-info"><p>Take advantage of Loanintap's quick financing options to grab lucrative possibilities and exclusive offers. Get quick access to money for necessary or desirable purchases, so you don't pass up good opportunities..</p></div>
               {/*  <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-loan-1"></i></div>
                <hr />
                <span>04</span>
                <div className="services-three-box-title"><h3>Personal Loans</h3></div>
                <div className="services-three-box-info"><p>Get instant funds for weddings, travel, medical emergencies with simple documentation, ensuring quick approval and a smooth, stress-free borrowing experience tailored to your needs.</p></div>
              {/*   <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-mortarboard"></i></div>
                <hr />
                <span>05</span>
                <div className="services-three-box-title"><h3>Loan for a Celebration</h3></div>
                <div className="services-three-box-info"><p>Use Festival Loan to enhance your unique moments without worrying. Our customised loans take the stress out of money, making special occasions like anniversaries and birthdays genuinely memorable.</p></div>
             {/*    <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-money-bag-1"></i></div>
                <hr />
                <span>06</span>
                <div className="services-three-box-title"><h3>Loan for Home Improvement</h3></div>
                <div className="services-three-box-info"><p>With home improvement loans, you can turn your living area into your ideal house, whether they are improvements to elevate your surroundings, renovations to create a peaceful retreat, or necessary furnishings.</p></div>
               {/*  <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Process One */}
      <section className="process-one">
        <div className="container">
          <div className="row gutter-y-30">
            <div className="col-lg-6">
              <div className="heading-box">
                <span className="heading-subtitle wow fadeInUp animated animated">🤝 OUR PROCESS</span>
                <h2 className="heading-title wow fadeInUp animated animated">Your Fast Loan Journey — Only 5 Steps Away</h2>
                <p className="heading-details">Our streamlined process ensures a smooth journey from your first enquiry to final approval. Enjoy personalised support and expert guidance at every step.</p>
              </div>
            </div>
            <div className="col-xl-12 col-md-8 align-self-center">
              <div className="process-item-one wow fadeInRight animated animated" data-wow-delay="500ms" data-wow-duration="2000ms">
                <div className="process-one-box">
                  <div className="process-one-box-icon"><i className="flaticon-application"></i></div>
                  <div className="process-one-box-title"><h3>Application</h3></div>
                  <div className="process-one-box-devider"></div>
                  <div className="process-one-box-details"><p>Start your loan application by filling out a quick form with your basic details, preferred loan amount, and monthly income — a process that takes only a few minutes.</p></div>
                </div>
               {/*  <div className="process-one-box">
                  <div className="process-one-box-icon"><i className="flaticon-contract"></i></div>
                  <div className="process-one-box-title"><h3>Consultation</h3></div>
                  <div className="process-one-box-devider"></div>
                  <div className="process-one-box-details"><p>As your trusted channel partner, Wallstreet Finz connects applicants with the right banks or NBFCs, guiding them toward the most suitable loan products.</p></div>
                </div> */}
                <div className="process-one-box">
                  <div className="process-one-box-icon"><i className="flaticon-approval"></i></div>
                  <div className="process-one-box-title"><h3>Documentation</h3></div>
                  <div className="process-one-box-devider"></div>
                  <div className="process-one-box-details"><p>After submitting your application, you will receive an email requesting any additional documents required to complete the process. Our team will then review your details and assess your loan eligibility based on our company’s criteria.</p></div>
                </div>
                <div className="process-one-box">
                  <div className="process-one-box-icon"><i className="flaticon-approval"></i></div>
                  <div className="process-one-box-title"><h3>Approval</h3></div>
                  <div className="process-one-box-devider"></div>
                  <div className="process-one-box-details"><p>Our Team review the application and verified documents to provide quick approval decisions, while we coordinate the process to minimize delays and keep customers updated at every step.</p></div>
                </div>
                <div className="process-one-box">
                  <div className="process-one-box-icon"><i className="flaticon-money-1"></i></div>
                  <div className="process-one-box-title"><h3>Disbursal</h3></div>
                  <div className="process-one-box-devider"></div>
                  <div className="process-one-box-details"><p>Once approved, the loan amount is disbursed directly to the customer’s account. Wallstreet Finz ensures complete transparency and provides full support until the disbursal is successfully completed.</p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Testimonial Two
      <div className="testimonial-two">
        <div className="testimonial-shape-one-1"><img alt="shape" src="/assets/images/shape/testimonial-shape-two-1.png" /></div>
        <div className="container">
          <div className="heading-box">
            <span className="heading-subtitle wow fadeInUp animated animated">🤝 TESTIMONIAL</span>
            <h2 className="heading-title wow fadeInUp animated animated">What our customers are saying</h2>
          </div>
          <div className="testimonial-slider-two">
            <div className="testimonial-slider-two-item">
              <div className="testimonial-slider-two-box">
                <div className="testimonial-two-box-meta">
                  <div className="testimonial-two-membar">
                    <h5>Sinchana Bhat</h5>
                    <span>Bangalore</span>
                  </div>
                </div>
                <p>Quick, reliable, and transparent - that's my experience with Wallstreet Finz. A trusted partner for all financial needs.</p>
                <span className="tagline">Home Loan</span>
                <div className="last-quote text-end"><i className="flaticon-quote-1"></i></div>
              </div>
            </div>
            <div className="testimonial-slider-two-item">
              <div className="testimonial-slider-two-box">
                <div className="testimonial-two-box-meta">
                  <div className="testimonial-two-membar">
                    <h5>Khoushal D</h5>
                    <span></span>
                  </div>
                </div>
                <p>Thank you, Wallstreet Finz and Mr. Manohar Koujageri for making my loan journey so smooth and stress-free. Truly appreciate your expert guidance !</p>
                <span className="tagline">Business Loan</span>
                <div className="last-quote text-end"><i className="flaticon-quote-1"></i></div>
              </div>
            </div>
            <div className="testimonial-slider-two-item">
              <div className="testimonial-slider-two-box">
                <div className="testimonial-two-box-meta">
                  <div className="testimonial-two-membar">
                    <h5>Praveen</h5>
                    <span>Home Owner</span>
                  </div>
                </div>
                <p>I highly recommend Geetha Prakash from Wallstreet Finz, especially for B khata properties and other special cases. GP's expertise and personalized approach made securing my construction loan surprisingly easy.</p>
                <span className="tagline">Home Loan</span>
                <div className="last-quote text-end"><i className="flaticon-quote-1"></i></div>
              </div>
            </div>
            <div className="testimonial-slider-two-item">
              <div className="testimonial-slider-two-box">
                <div className="testimonial-two-box-meta">
                  <div className="testimonial-two-membar">
                    <h5>Gunasekar P</h5>
                    <span>Homeowner</span>
                  </div>
                </div>
                <p>It gives me immense pleasure to write about Wallstreet Finz and the consultant Prabha who helped me with getting housing loan for premium property in Bangalore. They have not only helped me with loan, they also supported with some changes builder asked and have done all the work without me visiting their office once.</p>
                <span className="tagline">Home Loan</span>
                <div className="last-quote text-end"><i className="flaticon-quote-1"></i></div>
              </div>
            </div>
            <div className="testimonial-slider-two-item">
              <div className="testimonial-slider-two-box">
                <div className="testimonial-two-box-meta">
                  <div className="testimonial-two-membar">
                    <h5>Ashutosh Singh</h5>
                    <span>Home Owner</span>
                  </div>
                </div>
                <p>I had an exceptional experience securing a home loan through Wallstreet Finz. Adarsh was incredibly helpful throughout the entire process, requiring minimal effort on my part. His proactive approach ensured that all my queries and concerns were swiftly addressed. I highly recommend Wallstreet Finz for their outstanding service.</p>
                <span className="tagline">Home Loan</span>
                <div className="last-quote text-end"><i className="flaticon-quote-1"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
     
    </>
  );
}